import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/vercel/path0/node_modules/@heroui/link/dist/index.mjs");
